var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"start-teaching-advantages"},[_c('BaseTitleSection',{attrs:{"title":_vm.title}}),_vm._v(" "),_c('AdvantagesList',{attrs:{"list":_vm.list}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }